module.exports = __webpack_public_path__ + "img/fa.0b9d3a76.png";